import { Center } from '@zorro/web/design-system';
import React from 'react';

import { SVGIconProps } from '../types';

type Props = {
  style?: SVGIconProps;
  className?: string;
};

export const EmptyShoppingFlowPlanResults = ({ style, className }: Props) => {
  return (
    <Center style={style} className={className}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="158"
        height="145"
        viewBox="0 0 158 145"
        fill="none"
      >
        <rect
          x="0.75"
          y="0.75"
          width="145.5"
          height="37.5"
          rx="4.75"
          stroke="#EDEFF6"
          strokeWidth="1.5"
        />
        <rect
          x="10.26"
          y="14.26"
          width="22.48"
          height="10.48"
          rx="1.24"
          stroke="#EDEFF6"
          strokeWidth="1.52"
        />
        <rect x="41.5" y="13.5" width="64" height="4" rx="2" fill="#EDEFF6" />
        <rect x="41.5" y="21.5" width="11" height="4" rx="2" fill="#EDEFF6" />
        <rect x="56.5" y="21.5" width="11" height="4" rx="2" fill="#EDEFF6" />
        <rect x="71.5" y="21.5" width="11" height="4" rx="2" fill="#EDEFF6" />
        <rect x="113.5" y="5.5" width="28" height="28" rx="2" fill="#EDEFF6" />
        <rect
          x="0.75"
          y="48.75"
          width="145.5"
          height="37.5"
          rx="4.75"
          stroke="#EDEFF6"
          strokeWidth="1.5"
        />
        <rect
          x="10.26"
          y="62.26"
          width="22.48"
          height="10.48"
          rx="1.24"
          stroke="#EDEFF6"
          strokeWidth="1.52"
        />
        <rect x="41.5" y="61.5" width="64" height="4" rx="2" fill="#EDEFF6" />
        <rect x="41.5" y="69.5" width="11" height="4" rx="2" fill="#EDEFF6" />
        <rect x="56.5" y="69.5" width="11" height="4" rx="2" fill="#EDEFF6" />
        <rect x="71.5" y="69.5" width="11" height="4" rx="2" fill="#EDEFF6" />
        <rect x="113.5" y="53.5" width="28" height="28" rx="2" fill="#EDEFF6" />
        <rect
          x="0.75"
          y="96.75"
          width="145.5"
          height="37.5"
          rx="4.75"
          stroke="#EDEFF6"
          strokeWidth="1.5"
        />
        <rect
          x="10.26"
          y="110.26"
          width="22.48"
          height="10.48"
          rx="1.24"
          stroke="#EDEFF6"
          strokeWidth="1.52"
        />
        <rect x="41.5" y="109.5" width="64" height="4" rx="2" fill="#EDEFF6" />
        <rect x="41.5" y="117.5" width="11" height="4" rx="2" fill="#EDEFF6" />
        <rect x="56.5" y="117.5" width="11" height="4" rx="2" fill="#EDEFF6" />
        <rect x="71.5" y="117.5" width="11" height="4" rx="2" fill="#EDEFF6" />
        <rect
          x="113.5"
          y="101.5"
          width="28"
          height="28"
          rx="2"
          fill="#EDEFF6"
        />
        <rect
          x="107.5"
          y="94.5"
          width="44"
          height="44"
          rx="22"
          fill="#EDEFF6"
          stroke="white"
          strokeWidth="12"
        />
        <path
          d="M135.5 122.5L131.5 118.5M123.5 115.167C123.5 115.78 123.621 116.386 123.855 116.953C124.09 117.519 124.433 118.033 124.867 118.466C125.3 118.9 125.815 119.244 126.381 119.478C126.947 119.713 127.554 119.833 128.167 119.833C128.78 119.833 129.386 119.713 129.953 119.478C130.519 119.244 131.033 118.9 131.466 118.466C131.9 118.033 132.244 117.519 132.478 116.953C132.713 116.386 132.833 115.78 132.833 115.167C132.833 114.554 132.713 113.947 132.478 113.381C132.244 112.815 131.9 112.3 131.466 111.867C131.033 111.433 130.519 111.09 129.953 110.855C129.386 110.621 128.78 110.5 128.167 110.5C127.554 110.5 126.947 110.621 126.381 110.855C125.815 111.09 125.3 111.433 124.867 111.867C124.433 112.3 124.09 112.815 123.855 113.381C123.621 113.947 123.5 114.554 123.5 115.167Z"
          stroke="#676979"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </Center>
  );
};
